import React, { useState, useEffect } from "react";
import { Container, Image, Row, Col, Table, Form } from "react-bootstrap";
import Media from "react-media";
import { NavLink, withRouter, Link } from "react-router-dom";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import { RightSideCountTop } from "../../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { ExperienceTableHead } from "./ExperienceTableHead";
import NoContent from "../../../reusableComponents/NoContentComponent";
import ExpRequestBodyCard from "./ExpRequestBodyCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { amApi } from "../../../../api/apiHelper";
import ExpDashboardIcons from "./ExpDashboardIcons";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { successAlert } from "../../../../function/alert";
import BasicPagination from "../../../Pagination/Pagination";
import _ from "lodash";
import PaxFilter from "../../../reusableComponents/paxFilter";
import AllIcon from "../../../../assets/images/Orders/ordersall.png";
import SearchBar from "../../../reusableComponents/SearchBar";
import StatusFilter from "./Modals/StatusFilter";
import filterDinnersByPax from "../../../../function/experiencePaxFilter";

const seatingNew = require("../../../../assets/images/seatingImages/specialexp.png");
const pendingNew = require("../../../../assets/images/seatingImages/pendingexp.png");
const historyNew = require("../../../../assets/images/seatingImages/curatedexp.png");
const histNew = require("../../../../assets/images/seatingImages/historyexp.png");

const ExperienceHistoryDashboard = () => {
  const [expRequests, setExpRequests] = useState(null);
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(1);
  const [stats, setStats] = useState({ active: 0, inactive: 0, historyCount: 0 })
  const paxOptions = [2, 4, 6, 8, 'All'];
  const [paxFilter, setPaxFilter] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [expStatus, setExpStatus] = useState('')

  const page = history?.location?.pathname.split('/').pop();

  const iconIndex = { 'experience': 0, 'special': 1, 'curated': 2, 'history': 3 };

  const [iconData, setIconData] = useState([
    {
      count: 0,
      link: `/experienceDashboard/pending`,
      icon: pendingNew,
      code: 'experience',
      name: 'Pending',
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/all`,
      icon: AllIcon,
      code: 'experience',
      name: 'All',
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/special`,
      icon: seatingNew,
      code: 'special',
      name: "Occasions",
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/curated`,
      icon: historyNew,
      code: 'curated',
      name: "Events",
      showNotification: true
    },
    {
      count: 0,
      link: `/experienceDashboard/history`,
      icon: histNew,
      code: 'history',
      name: "History",
      showNotification: false
    }
  ]);

  const onStatusChange = async (type, formData, id) => {
    let patch = await amApi.patch(`/expRequest/${id}`, formData);
    let iconD = [...iconData]
    let data = [...expRequests]
    data = data.filter(ele => ele._id.toString() !== patch?.data?._id.toString());
    iconD[0].count -= 1;
    setExpRequests(data);
    setIconData(iconD)
    successAlert("Updated Successfully");
  }

  useEffect(() => {
    async function fetchData() {
      let response = await amApi.get(`/expRequest?status=all_history&page=${pagination || 1}&limit=10`);
      let stats = await amApi.get(`/expRequest?status=pending&type=STATS_BY_TYPE`);
      let icnData = [...iconData];
      icnData[0].count = stats?.data?.[0]?.pendingCount || 0;
      icnData[1].count = stats?.data?.[0]?.allCount || 0;
      icnData[2].count = stats?.data?.[0]?.specialCount || 0;
      icnData[3].count = stats?.data?.[0]?.curatedCount || 0;
      setIconData(icnData);
      setExpRequests(response.data);
    }
    if (page) {
      fetchData()
    }
  }, [page]);


  const handlePagination = async (pageNo) => {
    let response = await amApi.get(`/expRequest?status=all_history&page=${pageNo || 1}&limit=10`);
    setExpRequests(response.data);
    setPagination(pageNo);
  }

  let filterData = expRequests;
  if (search) {
    let searchData = new RegExp(search, "i");
    filterData = expRequests.filter((getall) => {
      if (
        searchData.test(
          getall?.userDetails?.name
        )
      ) {
        return getall;
      } else if (searchData.test(getall?.requestId)) {
        return getall;
      }
      else {
        return false;
      }
    });
  }

  if (paymentStatus !== "" && paymentStatus != 10) {
    filterData = filterData.filter((ele) => ele.paymentStatus === paymentStatus)
  }

  if (paymentMethod !== "" && paymentMethod != 10) {
    filterData = filterData.filter((ele) => ele?.paymentData?.paymentMethod === paymentMethod)
  }

  if (expStatus !== "" && expStatus != 10) {
    filterData = filterData.filter((ele) => ele?.status === expStatus)
  }

  filterData = filterDinnersByPax(filterData, paxFilter);

  filterData = _.groupBy(filterData, (data) =>
    moment(data["updatedAt"]).format("Do MMM, YYYY"));

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="mt-3 d-flex justify-content-between align-items-center">
          <div className="col-6">
            <ExpDashboardIcons data={iconData} page={page} exp={null} history={history} />
          </div>
          <div>
            <span className="p-2 px-3 f12-500" style={{ minWidth: '60px', color: "white", borderRadius: '30px', backgroundColor: "rgb(248, 80, 50)", cursor: 'pointer' }} onClick={() => history.push('/specialDashboard')}>
              Manage Experiences
            </span>
          </div>
        </div>

        <hr />
        <div className="">
          <div className="d-flex justify-content-between align-items-center">
            <SearchBar onChange={setSearch} />
            <PaxFilter options={paxOptions} selected={paxFilter} setSelected={setPaxFilter} />
            <div className="d-flex align-items-center justify-content-end">
              < StatusFilter
                statusfilter={false}
                experiencestatus={history?.location?.pathname?.includes('pending') ? false : true}
                paymentTypeFilter={true}
                paymentMethodfilter={true}
                paymentMethodValues={(e) => {
                  setPaymentMethod(e);
                }}
                paymentstatuvalues={(e) => {
                  setPaymentStatus(e);
                }}
                expstatusvalues={(e) => { setExpStatus(e) }}
              />
              <div className="f10-400" align="center">
                <img
                  src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                  width="48px"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2 p-1">
          <div className={"col-12 p-2 px-3"}>
            <div className="col-12 mpr-6 mobile-p-1 user-table-reusable-superadmin font_16_r">
              <Table>
                <thead style={{ position: 'sticky', top: '2px', zIndex: 10 }}>
                  <ExperienceTableHead />
                </thead>
                {!expRequests ? <SmallLoader />
                  : expRequests?.length == 0 ? <NoContent />
                    : Object.keys(filterData).map(key => <>
                      <div className="col-12 today-date-dropdown-seating-dashboard">
                        <div>
                          <h4>{key}</h4>
                        </div>
                        <div className="seating-dashboard-today-line">
                          <hr className="line" />
                        </div>
                      </div>
                      {filterData[key].map(expRequest => < ExpRequestBodyCard expRequest={expRequest} onStatusChange={onStatusChange} />)}
                    </>
                    )
                }
              </Table>
            </div>
          </div>
        </div>
        <BasicPagination
          totalRecords={stats.historyCount}
          limit={10}
          batch={pagination}
          onBatchChange={(e) => handlePagination(e)}
        />
      </div>
    </React.Fragment >
  );
};

export default ExperienceHistoryDashboard;
